// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import * as selectors from '../../../reducers';
import * as studentActions from '../../../actions/students';
import type { STUDENT_TYPE } from '../../../types/student';
import ContactCard from '../../StudentCard/ContactCard';
import { getUserImage } from '../../../utils';

type StudentsPanelPropTypes = {
  students: Array<STUDENT_TYPE>,
  parentId: number,
  removeStudentParentStarted: Function,
  updateStudent: Function,
};

const StudentsPanel = (
  {
    students,
    removeStudentParentStarted,
    parentId,
    updateStudent,
  }: StudentsPanelPropTypes,
) => (
  <Fragment>
    {
      students.map(student => (
        <ContactCard
          key={student.id}
          id={student.id}
          firstName={student.user.first_name}
          lastName={student.user.last_name}
          userRole="student"
          clickAction={() => removeStudentParentStarted(student.id, parentId)}
          updateProfile={updateStudent}
          phone={student.user.phone}
          email={student.user.email}
          pictureURL={getUserImage(student.user.profile_picture)}
          editable
        />
      ))
    }
  </Fragment>

);

const StudentsPanelComponent = connect(
  (state, { parentId }) => {
    const students = selectors.getParentStudents(state, parentId);
    return {
      students,
    };
  },
  dispatch => ({
    removeStudentParentStarted: (
      idStudent: number,
      idParent: number,
    ) => dispatch(studentActions.removeStudentParentStarted(idStudent, idParent)),
    updateStudent(student) {
      dispatch(studentActions.updateStudentStart({ ...student }));
    },
  }),
  undefined,
)(StudentsPanel);


export default StudentsPanelComponent;



// WEBPACK FOOTER //
// ./src/scripts/components/ParentCard/StudentsPanel/index.jsx